<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div class="row align-items-center mb-4">
                <div class="col-md-4">
                  <h2 class="page-title mb-md-0 mb-3">
                    <!-- <a href="javascript:void(0)"
                      ><img
                        src="images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a> -->
                    Search
                  </h2>
                </div>
                <div
                  class="col-md-8 form-style d-flex justify-content-end"></div>
              </div>
              <div class="row align-items-center mb-2">
                <div class="col-lg-6">
                  <ul
                    class="nav nav-pills mb-3 tab-style-1"
                    id="login-tab"
                    role="tablist">
                    <li class="nav-item" role="presentation">
                      <a
                        class="cursor-pointer nav-link"
                        :class="currentTab == 'BASIC' ? 'activ' : ''"
                        id="email-tab"
                        v-on:click="changeTab('BASIC')"
                        >Search</a
                      >
                    </li>
                    <li class="nav-item" role="presentation">
                      <a
                        class="cursor-pointer nav-link"
                        id="phone-tab"
                        :class="currentTab == 'ID' ? 'activ' : ''"
                        v-on:click="changeTab('ID')"
                        >Search by profile ID</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tab-content form-style">
                <div
                  class="tab-pane fade"
                  :class="currentTab == 'BASIC' ? 'show active' : ''"
                  id="tab_1"
                  v-if="currentTab == 'BASIC'">
                  <Form @submit="basicSearch()">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Marital Status</label>
                          <Multiselect
                            mode="tags"
                            :searchable="true"
                            name="marrital_status"
                            v-model="detail.marital_status_id"
                            trackBy="uuid"
                            label="name"
                            valueProp="uuid"
                            :options="marital_status_list"
                            placeholder="Marital Status"
                            @select="SelectAllMarriedList($event)" />
                        </div>
                      </div>
                      <div class="col-md-6 mb-2">
                        <div class="form-group">
                          <label for="">Same Devak</label>
                          <Field
                            as="select"
                            class="form-control"
                            id="inputRole"
                            name="same_devak"
                            v-model="detail.same_devak">
                            <option value="">Select</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row align-items-end">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Birth Years </label>
                              <Datepicker
                                autoApply
                                v-model="from_age"
                                inputFormat="dd-MM-yyyy"
                                format="yyyy"
                                placeholder="Select Year"
                                :maxDate="new Date()"
                                yearPicker />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <!-- <Field
                                type="text"
                                id="to_age"
                                class="form-control"
                                style="
                                  background-color: white !important;
                                  border: 1px solid rgba(237, 237, 237, 0.85) !important;
                                  height: 53px;
                                "
                                name="to-age"
                                placeholder="To Age"
                                v-model="detail.to_age"
                              /> -->
                              <Datepicker
                                autoApply
                                v-model="to_age"
                                inputFormat="dd-MM-yyyy"
                                format="yyyy"
                                placeholder="Select Year"
                                :maxDate="new Date()"
                                v-bind="field"
                                yearPicker />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row align-items-end">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Height</label>

                              <Field
                                as="select"
                                class="form-control"
                                id="inputRole"
                                name="from-height"
                                placeholder="From Height"
                                v-model="detail.from_height">
                                <option value="">Select Height</option>
                                <option value="139">
                                  {{ $helperService.getHeight(139) }}
                                </option>
                                <option value="142">
                                  {{ $helperService.getHeight(142) }}
                                </option>
                                <option value="144">
                                  {{ $helperService.getHeight(144) }}
                                </option>
                                <option value="147">
                                  {{ $helperService.getHeight(147) }}
                                </option>
                                <option value="149">
                                  {{ $helperService.getHeight(149) }}
                                </option>
                                <option value="152">
                                  {{ $helperService.getHeight(152) }}
                                </option>
                                <option value="154">
                                  {{ $helperService.getHeight(154) }}
                                </option>
                                <option value="157">
                                  {{ $helperService.getHeight(157) }}
                                </option>
                                <option value="160">
                                  {{ $helperService.getHeight(160) }}
                                </option>
                                <option value="162">
                                  {{ $helperService.getHeight(162) }}
                                </option>
                                <option value="165">
                                  {{ $helperService.getHeight(165) }}
                                </option>
                                <option value="167">
                                  {{ $helperService.getHeight(167) }}
                                </option>
                                <option value="170">
                                  {{ $helperService.getHeight(170) }}
                                </option>
                                <option value="172">
                                  {{ $helperService.getHeight(172) }}
                                </option>
                                <option value="175">
                                  {{ $helperService.getHeight(175) }}
                                </option>
                                <option value="177">
                                  {{ $helperService.getHeight(177) }}
                                </option>
                                <option value="180">
                                  {{ $helperService.getHeight(180) }}
                                </option>
                                <option value="182">
                                  {{ $helperService.getHeight(182) }}
                                </option>
                                <option value="185">
                                  {{ $helperService.getHeight(185) }}
                                </option>
                                <option value="187">
                                  {{ $helperService.getHeight(187) }}
                                </option>
                                <option value="190">
                                  {{ $helperService.getHeight(190) }}
                                </option>
                                <option value="192">
                                  {{ $helperService.getHeight(192) }}
                                </option>
                                <option value="195">
                                  {{ $helperService.getHeight(195) }}
                                </option>
                                <option value="198">
                                  {{ $helperService.getHeight(198) }}
                                </option>
                                <option value="200">
                                  {{ $helperService.getHeight(200) }}
                                </option>
                                <option value="203">
                                  {{ $helperService.getHeight(203) }}
                                </option>
                                <option value="205">
                                  {{ $helperService.getHeight(205) }}
                                </option>
                                <option value="208">
                                  {{ $helperService.getHeight(208) }}
                                </option>
                                <option value="210">
                                  {{ $helperService.getHeight(210) }}
                                </option>
                                <option value="213">
                                  {{ $helperService.getHeight(213) }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <Field
                                as="select"
                                class="form-control"
                                id="height"
                                name="to-height"
                                placeholder="To Height"
                                v-model="detail.to_height">
                                <option value="">Select Height</option>
                                <option value="139">
                                  {{ $helperService.getHeight(139) }}
                                </option>
                                <option value="142">
                                  {{ $helperService.getHeight(142) }}
                                </option>
                                <option value="144">
                                  {{ $helperService.getHeight(144) }}
                                </option>
                                <option value="147">
                                  {{ $helperService.getHeight(147) }}
                                </option>
                                <option value="149">
                                  {{ $helperService.getHeight(149) }}
                                </option>
                                <option value="152">
                                  {{ $helperService.getHeight(152) }}
                                </option>
                                <option value="154">
                                  {{ $helperService.getHeight(154) }}
                                </option>
                                <option value="157">
                                  {{ $helperService.getHeight(157) }}
                                </option>
                                <option value="160">
                                  {{ $helperService.getHeight(160) }}
                                </option>
                                <option value="162">
                                  {{ $helperService.getHeight(162) }}
                                </option>
                                <option value="165">
                                  {{ $helperService.getHeight(165) }}
                                </option>
                                <option value="167">
                                  {{ $helperService.getHeight(167) }}
                                </option>
                                <option value="170">
                                  {{ $helperService.getHeight(170) }}
                                </option>
                                <option value="172">
                                  {{ $helperService.getHeight(172) }}
                                </option>
                                <option value="175">
                                  {{ $helperService.getHeight(175) }}
                                </option>
                                <option value="177">
                                  {{ $helperService.getHeight(177) }}
                                </option>
                                <option value="180">
                                  {{ $helperService.getHeight(180) }}
                                </option>
                                <option value="182">
                                  {{ $helperService.getHeight(182) }}
                                </option>
                                <option value="185">
                                  {{ $helperService.getHeight(185) }}
                                </option>
                                <option value="187">
                                  {{ $helperService.getHeight(187) }}
                                </option>
                                <option value="190">
                                  {{ $helperService.getHeight(190) }}
                                </option>
                                <option value="192">
                                  {{ $helperService.getHeight(192) }}
                                </option>
                                <option value="195">
                                  {{ $helperService.getHeight(195) }}
                                </option>
                                <option value="198">
                                  {{ $helperService.getHeight(198) }}
                                </option>
                                <option value="200">
                                  {{ $helperService.getHeight(200) }}
                                </option>
                                <option value="203">
                                  {{ $helperService.getHeight(203) }}
                                </option>
                                <option value="205">
                                  {{ $helperService.getHeight(205) }}
                                </option>
                                <option value="208">
                                  {{ $helperService.getHeight(208) }}
                                </option>
                                <option value="210">
                                  {{ $helperService.getHeight(210) }}
                                </option>
                                <option value="213">
                                  {{ $helperService.getHeight(213) }}
                                </option>
                              </Field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>Education</label>
                          <Multiselect
                            ref="multiselect"
                            name="maritalstatusList"
                            mode="tags"
                            trackBy="name"
                            label="name"
                            valueProp="uuid"
                            placeholder="Select"
                            v-model="detail.education_group_id"
                            :options="education_group"
                            :searchable="true"
                            :createOption="false"
                            @select="SelectAllEducationList($event)" />
                          <!-- object="true" -->
                          <!-- <Multiselect
                            mode="tags"
                            :searchable="true"
                            name="education_group_id"
                            v-model="detail.education_group_id"
                            trackBy="name"
                            label="name"
                            valueProp="uuid"
                            :options="education_group"
                            placeholder="Education Group"
                            object="true"
                            @select="SelectAllEducationList($event)"
                          /> -->
                        </div>
                      </div>
                      <div class="col-md-6" v-if="array.length <= 1">
                        <div class="form-group">
                          <label>Work Location</label>
                          <span style="color: red; font-weight: bold">
                            {{
                              detail.move_to_abroad.length > 0
                                ? "(To select this, Unselect “Ready Move to Abroad” )"
                                : ""
                            }}</span
                          >
                          <Multiselect
                            v-model="detail.working_place_id"
                            name="workingplaceList"
                            mode="tags"
                            track-by="name"
                            label="name"
                            value-prop="uuid"
                            placeholder="Select"
                            :options="filteredOptions"
                            :searchable="true"
                            :create-option="false"
                            :internal-search="false"
                            :disabled="detail.move_to_abroad.length > 0"
                            @search-change="onSearchChange" />
                          <!-- <Multiselect
                            v-model="detail.working_place_ids"
                            :options="working_place_list"
                            :searchable="true"
                            :createOption="false"
                            mode="tags"
                          /> -->
                        </div>
                      </div>
                      <div class="col-md-6" v-if="array.length <= 1">
                        <div class="form-group">
                          <label>Native Dist.</label>
                          <Multiselect
                            ref="multiselect"
                            name="nativeplaceList"
                            mode="tags"
                            trackBy="name"
                            label="name"
                            valueProp="uuid"
                            placeholder="Select"
                            v-model="detail.native_place_id"
                            :options="native_place_list"
                            :searchable="true"
                            :createOption="false" />
                        </div>
                      </div>
                      <div class="col-md-6" v-if="array.length <= 1">
                        <div class="form-group">
                          <label>Occupation Type</label>
                          <Multiselect
                            ref="multiselect"
                            name="occupationList"
                            mode="tags"
                            trackBy="name"
                            label="name"
                            valueProp="uuid"
                            placeholder="Select"
                            v-model="detail.occupation_type_id"
                            :options="occupation_list"
                            :searchable="true"
                            :createOption="false"
                            @select="SelectAllOcupationList($event)" />
                        </div>
                      </div>
                      <div class="col-md-6" v-if="array.length <= 1">
                        <div class="form-group">
                          <label>Diet</label>
                          <Multiselect
                            ref="multiselect"
                            name="dietList"
                            mode="tags"
                            trackBy="name"
                            label="name"
                            valueProp="uuid"
                            placeholder="Select"
                            v-model="detail.diet_ids"
                            :options="diet_list"
                            :searchable="true"
                            :createOption="false"
                            @select="SelectAllDietList($event)" />
                        </div>
                      </div>
                      <div class="col-md-6" v-if="array.length <= 1">
                        <div class="form-group">
                          <label>Ready Move to Abroad </label>
                          <span style="color: red; font-weight: bold">
                            {{
                              detail.working_place_id.length > 0
                                ? "( To select this, Unselect “Work Location” )"
                                : ""
                            }}</span
                          >
                          <Multiselect
                            style="
                              font-size: 14px;
                              color: #000;
                              font-weight: 500;
                            "
                            mode="tags"
                            :disabled="detail.working_place_id.length > 0"
                            :searchable="true"
                            name="move_to_abroad"
                            v-model="detail.move_to_abroad"
                            trackBy="name"
                            label="name"
                            valueProp="name"
                            :options="moveToAbroadList"
                            placeholder="Move to Abroad"
                            @select="SelectAllMoveToAbroadList($event)" />
                        </div>
                      </div>
                      <div class="col-12 text-center mt-4">
                        <button id="search-list" class="btn btn-brand-1 px-5">
                          Search
                        </button>
                      </div>
                    </div>
                  </Form>
                  <div v-if="isShow" class="text-center">
                    <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
                      <h3 class="mb-4">
                        <strong>Profile Not Found</strong>
                      </h3>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="tab_2"
                  :class="currentTab == 'ID' ? 'show active' : ''"
                  v-if="currentTab == 'ID'">
                  <Form @submit="idSearch()">
                    <div class="form-group">
                      <label>Search By ID</label>
                      <Field
                        type="text"
                        id="searchId"
                        class="form-control"
                        name="searchId"
                        style=""
                        placeholder="Enter Profile ID"
                        v-model="registration_no"
                        rules="required: registration id"
                        :validateOnInput="true" />
                    </div>
                    <ErrorMessage name="searchId" class="validation-msg" />
                    <div class="col-12 text-center mt-4">
                      <button id="search-id" class="btn btn-brand-1 px-5">
                        Search
                      </button>
                    </div>
                    <div v-if="isShow" class="text-center">
                      <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
                        <h3 class="mb-4">
                          <strong>Profile Not Found</strong>
                        </h3>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <ErrorComponent @retry="getSearchJson()" ref="errorComponent" />
  </div>
</template>
<script>
import Multiselect from "@vueform/multiselect";
import ErrorComponent from "@/components/ErrorComponent";
import { Form, Field, ErrorMessage } from "vee-validate";
import Datepicker from "@vuepic/vue-datepicker";

export default {
  name: "SearchBy",
  components: {
    Multiselect,
    ErrorComponent,
    Form,
    Field,
    ErrorMessage,
    Datepicker,
  },
  data() {
    return {
      type: this.$route.params.type,
      from_age: "",
      to_age: "",
      detail: {
        diet_ids: [],
        education_group_id: [],
        from_age: "",
        from_height: "",
        same_devak: "N",
        native_place_id: [],
        marital_status_id: [],
        occupation_type_id: [],
        to_age: "",
        to_height: "",
        working_place_id: [],
        move_to_abroad: [],
      },
      marital_status_list: [{ name: "Select All", uuid: "Select All" }],
      working_place_list: [],
      native_place_list: [],
      education_group: [{ name: "Select All", uuid: "Select All" }],
      occupation_list: [{ name: "Select All", uuid: "Select All" }],
      diet_list: [{ name: "Select All", uuid: "Select All" }],
      moveToAbroadList: [{ name: "Select All", uuid: "Select All" }],
      currentTab: "BASIC",
      array: [],
      registration_no: "",
      search_json: "",
      isShow: false,
      searchText: "",
    };
  },
  mounted() {
    this.getReadyToMove();
    this.getWorkingPlace();
    this.getNativePlace();
    this.getOccupation();
    this.getDiet();
    this.getEducationGroup("EDUCATION_GROUP");
    this.getMaritalList();
    this.changeTab(this.currentTab);
    // if (this.type) {
    setTimeout(() => {
      this.getSearchJson();
    }, 500);
    // }
    this.moveToContacat();
    document.getElementById("navbarSupportedContent").classList.remove("show");
  },
  computed: {
    filteredOptions() {
      const keyword = this.searchText.toLowerCase().trim();
      if (!keyword) return this.working_place_list;
      return this.working_place_list.filter((opt) =>
        opt.name.toLowerCase().startsWith(keyword)
      );
    },
  },
  methods: {
    onSearchChange(val) {
      this.searchText = val;
    },
    moveToContacat() {
      window.scrollTo(-1000, -1000);
    },
    SelectAllMoveToAbroadList(e) {
      var temp = [];
      if (e == "Select All") {
        for (var i = 0; i < this.moveToAbroadList.length; i++) {
          var obj = this.moveToAbroadList[i];
          if (obj.name != "Select All") {
            temp.push(obj.name);
          } else {
            obj.name = "Deselect All";
            obj.uuid = "Deselect All";
          }
        }
        this.detail.move_to_abroad = temp;
      } else if (e == "Deselect All") {
        this.detail.move_to_abroad = [];
        for (var j in this.moveToAbroadList) {
          if (this.moveToAbroadList[j].name == "Deselect All") {
            this.moveToAbroadList[j].uuid = "Select All";
            this.moveToAbroadList[j].name = "Select All";
          }
        }
      }
    },
    SelectAllDietList(e) {
      var temp = [];
      if (e == "Select All") {
        for (var i = 0; i < this.diet_list.length; i++) {
          var obj = this.diet_list[i];
          if (obj.uuid != "Select All") {
            temp.push(obj.uuid);
          } else {
            obj.name = "Deselect All";
            obj.uuid = "Deselect All";
          }
        }
        this.detail.diet_ids = temp;
      } else if (e == "Deselect All") {
        this.detail.diet_ids = [];
        for (var j in this.diet_list) {
          if (this.diet_list[j].uuid == "Deselect All") {
            this.diet_list[j].uuid = "Select All";
            this.diet_list[j].name = "Select All";
          }
        }
      }
    },
    SelectAllEducationList(e) {
      var temp = [];
      if (e == "Select All") {
        for (var i = 0; i < this.education_group.length; i++) {
          var obj = this.education_group[i];
          if (obj.uuid != "Select All") {
            temp.push(obj.uuid);
          } else {
            obj.name = "Deselect All";
            obj.uuid = "Deselect All";
          }
        }
        this.detail.education_group_id = temp;
      } else if (e == "Deselect All") {
        this.detail.education_group_id = [];
        for (var j in this.education_group) {
          if (this.education_group[j].uuid == "Deselect All") {
            this.education_group[j].uuid = "Select All";
            this.education_group[j].name = "Select All";
          }
        }
      }
    },
    SelectAllOcupationList(e) {
      var temp = [];
      if (e == "Select All") {
        for (var i = 0; i < this.occupation_list.length; i++) {
          var obj = this.occupation_list[i];
          if (obj.uuid != "Select All") {
            temp.push(obj.uuid);
          } else {
            obj.name = "Deselect All";
            obj.uuid = "Deselect All";
          }
        }
        this.detail.occupation_type_id = temp;
      } else if (e == "Deselect All") {
        this.detail.occupation_type_id = [];
        for (var j in this.occupation_list) {
          if (this.occupation_list[j].uuid == "Deselect All") {
            this.occupation_list[j].uuid = "Select All";
            this.occupation_list[j].name = "Select All";
          }
        }
      }
    },
    getSelectValue(e) {
      if (e) {
        this.array = e.split(",");
      }
    },
    getSearchJson() {
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateFormLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/search-json-user",
        })
        .then((res) => {
          if (res.list && res.list.search_json) {
            this.search_json = JSON.parse(res.list.search_json);

            if (this.search_json.to_age) {
              this.to_age = this.search_json.to_age;
            }
            if (this.search_json.from_age) {
              this.from_age = this.search_json.from_age;
            }
            if (this.search_json.to_height) {
              this.detail.to_height = this.search_json.to_height;
            }
            if (this.search_json.from_height) {
              this.detail.from_height = this.search_json.from_height;
            }
            if (this.search_json.same_devak) {
              this.detail.same_devak = this.search_json.same_devak;
            }
            if (this.search_json.education_group_id) {
              this.detail.education_group_id =
                this.search_json.education_group_id?.split(",");
              let selectedCount = this.detail.education_group_id?.length;
              let totalCount = this.education_group?.length - 1;
              if (selectedCount == totalCount) {
                for (let q in this.education_group) {
                  if (this.education_group[q].uuid == "Select All") {
                    this.education_group[q].uuid = "Deselect All";
                    this.education_group[q].name = "Deselect All";
                  }
                }
              }
            }
            if (this.search_json.diet_ids) {
              this.detail.diet_ids = this.search_json.diet_ids?.split(",");
              let selectedCount = this.detail.diet_ids?.length;
              let totalCount = this.diet_list?.length - 1;
              if (selectedCount == totalCount) {
                for (let q in this.diet_list) {
                  if (this.diet_list[q].uuid == "Select All") {
                    this.diet_list[q].uuid = "Deselect All";
                    this.diet_list[q].name = "Deselect All";
                  }
                }
              }
            }
            if (this.search_json.move_to_abroad) {
              this.detail.move_to_abroad =
                this.search_json.move_to_abroad?.split(",");
              let selectedCount = this.detail.move_to_abroad?.length;
              let totalCount = this.moveToAbroadList?.length - 1;
              if (selectedCount == totalCount) {
                for (let q in this.moveToAbroadList) {
                  if (this.moveToAbroadList[q].uuid == "Select All") {
                    this.moveToAbroadList[q].uuid = "Deselect All";
                    this.moveToAbroadList[q].name = "Deselect All";
                  }
                }
              }
            }
            if (this.search_json.marital_status_id) {
              this.detail.marital_status_id =
                this.search_json.marital_status_id?.split(",");
              let selectedCount = this.detail.marital_status_id?.length;
              let totalCount = this.marital_status_list?.length - 1;
              if (selectedCount == totalCount) {
                for (let q in this.marital_status_list) {
                  if (this.marital_status_list[q].uuid == "Select All") {
                    this.marital_status_list[q].uuid = "Deselect All";
                    this.marital_status_list[q].name = "Deselect All";
                  }
                }
              }
            }
            if (this.search_json.native_place_id) {
              this.detail.native_place_id =
                this.search_json.native_place_id.split(",");
            }
            if (this.search_json.occupation_type_id) {
              this.detail.occupation_type_id =
                this.search_json.occupation_type_id?.split(",");
              let selectedCount = this.detail.occupation_type_id?.length;
              let totalCount = this.occupation_list?.length - 1;
              if (selectedCount == totalCount) {
                for (let q in this.occupation_list) {
                  if (this.occupation_list[q].uuid == "Select All") {
                    this.occupation_list[q].uuid = "Deselect All";
                    this.occupation_list[q].name = "Deselect All";
                  }
                }
              }
            }
            if (this.search_json.working_place_id) {
              this.detail.working_place_id =
                this.search_json.working_place_id.split(",");
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    getEducationGroup(status) {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + status,
        })
        .then((res) => {
          this.education_group = [...this.education_group, ...res.list];
        })
        .catch(() => {});
    },
    getWorkingPlace() {
      this.$api
        .getAPI({
          _action: "/work-location/list",
        })
        .then((res) => {
          this.working_place_list = res;
        })
        .catch(() => {});
    },
    getNativePlace() {
      this.$api
        .getAPI({
          _action: "/district/list",
        })
        .then((res) => {
          this.native_place_list = res;
        })
        .catch(() => {});
    },
    getOccupation() {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + "OCCUPATION_TYPE",
        })
        .then((res) => {
          this.occupation_list = [...this.occupation_list, ...res.list];
        })
        .catch(() => {});
    },
    getReadyToMove() {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + "MOVE_TO_ABROAD",
        })
        .then((res) => {
          this.moveToAbroadList = [...this.moveToAbroadList, ...res.list];
        })
        .catch(() => {});
    },
    getDiet() {
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + "DIET",
        })
        .then((res) => {
          this.diet_list = [...this.diet_list, ...res.list];
        })
        .catch(() => {});
    },
    getMaritalList() {
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateFormLoader(true);
      }
      this.$api
        .getAPI({
          _action: "/master-data/list?type=" + "MARITAL_STATUS",
        })
        .then((res) => {
          this.marital_status_list = [...this.marital_status_list, ...res.list];
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.isShow = true;
        });
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    idSearch() {
      var obj = {};
      obj.registration_no = this.registration_no;
      this.$api
        .getAPI({
          _action: "/search-by-id-web",
          _body: obj,
          _buttonId: "search-id",
        })
        .then((res) => {
          if (res) {
            this.$router.push("/profile-view/" + res.uuid);
          } else {
            this.$notify({
              type: "error",
              text: "Please enter valid Profile ID",
            });
          }
        })
        .catch(() => {
          this.isShow = true;
        });
    },
    basicSearch() {
      if (!this.from_age) {
        this.detail.from_age = "";
      } else {
        this.detail.from_age = this.from_age;
      }
      if (!this.to_age) {
        this.detail.to_age = "";
      } else {
        this.detail.to_age = this.to_age;
      }
      if (this.detail.marital_status_id == "null") {
        this.detail.marital_status_id = "";
      }

      this.$api
        .getAPI({
          _action: "/search-user",
          _body: this.detail,
          _buttonId: "search-list",
        })
        .then((res) => {
          if (res) {
            this.$router.push("/search-list");
            this.$store.commit("setSearchObject", this.detail);
          }
        })
        .catch(() => {
          this.isShow = true;
        });
    },
    SelectAllMarriedList(e) {
      var temp = [];
      if (e == "Select All") {
        for (var i = 0; i < this.marital_status_list.length; i++) {
          var obj = this.marital_status_list[i];
          if (obj.name != "Select All") {
            temp.push(obj.uuid);
          } else {
            obj.name = "Deselect All";
            obj.uuid = "Deselect All";
          }
        }
        this.detail.marital_status_id = temp;
      } else if (e == "Deselect All") {
        this.detail.marital_status_id = [];
        for (var j in this.marital_status_list) {
          if (this.marital_status_list[j].name == "Deselect All") {
            this.marital_status_list[j].name = "Select All";
            this.marital_status_list[j].uuid = "Select All";
          }
        }
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  /* background: white !important; */
  height: auto !important;
  border: 1px solid;
}

.multiselect-tag {
  background: #bd1c9c !important;
}
</style>
